import { render } from "./App.vue?vue&type=template&id=073f2f2f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pedro-guzman/Documents/sherpa/sherpa_digital/microservices/sherpa_salud_digital_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__